import {MutationTree} from "vuex";
import {DataProfileState, DataProfile} from "./model";

const mutations: MutationTree<DataProfileState> = {
  setDataProfiles(state, dataProfiles: DataProfile[]) {
    state.dataProfiles = dataProfiles;
  },
  addDataProfile(state, dataProfile: DataProfile) {
    state.dataProfiles.push(dataProfile);
  },
  updateDataProfile(state, dataProfile: DataProfile) {
    const c = state.dataProfiles.find(c => c.id === dataProfile.id);
    Object.assign(c, dataProfile);
  },
  deleteDataProfile(state, id: string) {
    state.dataProfiles = state.dataProfiles.filter(dataProfile => dataProfile.id !== id);
  }
}

export default mutations;
